<template>

<div id="location">
  <p>
    <!-- Click here to load the location data -->
    <!-- <button v-on:click="locateMe">Send Location to others</button> -->
    <!-- <button v-on:click="sendData">sendLocation</button> -->
  </p>
  
  <div v-if="errorStr">
    Sorry, but the following error
    occurred: {{errorStr}}
  </div>
  
  <div v-if="gettingLocation">
    <i>Getting your location...</i>
  </div>
  
  <div v-if="currentLocation">
    <div>
      Your currentLocation data is {{ currentLocation.coords.latitude }}, {{ currentLocation.coords.longitude}}
    </div>

    <div>
      Your city is {{city}}
    </div>

    <!-- <div>
      The distance between you is {{distance}} meter
    </div>   -->
  </div>

  <li id ="others" v-for="o in others" :key="o.key">
        <p>{{o}}</p>
  </li>
</div>


</template>

<script>
import axios from 'axios'

export default {

  name:"Location",
  props:{
    username: {
      type: String
    },
    activeRoom: {
      type: Object
    }
  },

  data() {
    return {
      currentLocation:null,
      gettingLocation: false,
      errorStr:null,
      city:null,
      distance: null,
      coordinates:null,
      others:[],
      position:null
    }
  },

created() {
  //  this.locateMe();
    // console.log(this.activeRoom);
    // console.log(this.username);
  },

  mounted () {
    let VueThis = this;
  }, 

    methods: {

    async send(){
      this.$socket.emit("location", {
          coordinates: this.coordinates,
          city: this.city,
          user: this.username,
          roomId: this.activeRoom.id
        }); 

    },
    async getLocation() {
      return new Promise((resolve, reject) => {
        if(!("geolocation" in navigator)) {
          this.errorStr = 'Geolocation is not available.';
          reject(new Error('Geolocation is not available.'));
        }

        var options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        };
        
        navigator.geolocation.getCurrentPosition(pos => {
          // this.send()
          resolve(pos);
        }, err => {
          // reject(err);
          reject({
            coords:{
              latitude:10,
              longitude:20
            }
          });
        },options);        

      });
    },

    async locateMe() {

      if(this.currentLocation == null) {
        // console.log(this.currentLocation)
        this.gettingLocation = true;
        try {
          // this.gettingLocation = false;
          // console.log('start');
          this.currentLocation = await this.getLocation();

          this.coordinates = {
            la:this.currentLocation.coords.latitude,
            lo :this.currentLocation.coords.longitude
          }
          this.lat = this.currentLocation.coords.latitude;
          this.lon = this.currentLocation.coords.longitude;
          
          axios
            .get(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${this.currentLocation.coords.latitude}&longitude=${this.currentLocation.coords.longitude}&localityLanguage=en`)
            .then((response )=> {
              // console.log( response);
              this.city = response.data.locality;
              this.send()
            })
        } catch(e) {
          this.gettingLocation = false;
          this.errorStr = e.message;
        }


        this.gettingLocation = false;
      }else{

        this.currentLocation=null;
        this.city=null;
        this.distance= null;
        this.coordinates= null;
      
      }

      this.$emit('coords',this.coordinates);
      return this.coordinates;
    },

    // getRandomNumberBetween = () =>{Math.floor(Math.random()*(max-min+1)+min)},

    distanceBetweenTwoGeo(lat1,lon1){

      const lat2 = this.currentLocation.coords.latitude;
      const lon2 = this.currentLocation.coords.longitude;
      const R = 6371e3; // metres
      const φ1 = lat1 * Math.PI/180; // φ, λ in radians
      const φ2 = lat2 * Math.PI/180;
      const Δφ = (lat2-lat1) * Math.PI/180;
      const Δλ = (lon2-lon1) * Math.PI/180;

      const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
                Math.cos(φ1) * Math.cos(φ2) *
                Math.sin(Δλ/2) * Math.sin(Δλ/2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

      const d = R * c; // in metres

      return d;
    }
  },
  sockets: {
    
    location: function(data) {
      console.log(data.user,data.coordinates.la,data.coordinates.lo)
      const meters = this.distanceBetweenTwoGeo(data.coordinates.la,data.coordinates.lo);
      this.others.push(`${data.user} is in ${data.city} ${meters}`);

    }
  }
}

</script>

<style lang="css" scoped>

#location {
  background-color: green;
  position:fixed;
  padding: 0;
  z-index: 1000;
  bottom: 100px;
  left: 5%;
  width: 50%;
}


button {
  margin:10px 10px 0px 10px;
  display:block;
  width: calc(100% - 20px);
}

</style>